import { v4 as uuidv4 } from "uuid";
import * as CryptoJs from "crypto-js";
import { JSEncrypt } from "jsencrypt";
import { env } from "@config";

export interface EncryptedData {
  r: string[];
}

export const encrypt = <T>(data: T): EncryptedData => {
  const jsEncrypt = new JSEncrypt();
  jsEncrypt.setPublicKey(env.encryption.publicKey);

  const aesKey = uuidv4();
  const encryptedAesKey = jsEncrypt.encrypt(aesKey) as string;
  const encryptedRequest = CryptoJs.AES.encrypt(JSON.stringify(data), aesKey).toString();

  return {
    r: [encryptedAesKey, encryptedRequest],
  };
};

export const decrypt = <T>(data: EncryptedData): T => {
  const jsEncrypt = new JSEncrypt();
  jsEncrypt.setPrivateKey(env.encryption.privateKey);

  const aesKey = jsEncrypt.decrypt(data?.r[0]) as string;
  const decryptedData: T | string = CryptoJs.AES.decrypt(data?.r[1], aesKey).toString(
    CryptoJs.enc.Utf8
  );

  if ((decryptedData as string)?.startsWith("{") || (decryptedData as string)?.startsWith("[")) {
    return JSON.parse(decryptedData as string) as T;
  }

  return decryptedData as T;
};
